(() => {
  const SELECTOR = '[data-w-hscroll]';
  const LINE_HEIGHT = 16; // deltaMode === DOM_DELTA_LINE

  const pixels = (event) => {
    if (event.deltaMode === 1) return event.deltaY * LINE_HEIGHT;
    if (event.deltaMode === 2) return event.deltaY * window.innerHeight;
    return event.deltaY;
  };

  document.addEventListener(
    'wheel',
    (event) => {
      const row = event.target.closest?.(SELECTOR);
      if (!row) return;

      if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;

      const max = row.scrollWidth - row.clientWidth;
      if (max <= 1) return; // pas de debord : rien a faire (cas desktop)

      const delta = pixels(event);
      if (!delta) return;

      if (delta < 0 && row.scrollLeft <= 0) return;
      if (delta > 0 && row.scrollLeft >= max - 1) return;

      event.preventDefault();
      row.scrollLeft += delta;
    },
    { passive: false }
  );
})();
